import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

const GoogleAuthHandler = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = searchParams.get("token");
    const type = searchParams.get("type");
    console.log(type)
    if (token) {
      if (type === "new") {
        localStorage.setItem("regToken", token);
        navigate("/personal-details");
      } else {
        localStorage.setItem("authToken", token);
        toast.success('Login Successfully..!!');
        navigate("/");
      }
    } else {
      toast.error("Google login failed. Please try again.");
      navigate("/signin");
    }
  }, [dispatch, navigate, searchParams]);

  return null;
};

export default GoogleAuthHandler;
